<!--
 * @Date: 2022-03-07 14:32:27
 * @LastEditTime: 2022-11-08 17:47:33
 * @Description: file content
-->
<template>
  <div class="company-psychological-counseling">
    <div v-if="isEnterprise" class="user-tip">
      <img src="../../assets/images/service.png" alt="" />
      <div class="free-count">您当月剩余免费咨询次数：{{ freeCount }}次</div>
    </div>
    <div class="banner">
      <input
        v-model="phone"
        class="phone"
        type="text"
        placeholder="请输入手机号码"
        disabled
      />
    </div>
    <img
      class="pc-img"
      src="https://resource.chunyu.mobi/@/media/images/2022/04/14/6de0/dd817d768601_w750_h916_.jpg"
    />
    <img
      class="pc-img"
      src="https://resource.chunyu.mobi/@/media/images/2022/04/14/f39f/c12082e87736_w750_h1010_.jpg"
    />
    <div class="feedback">
      <img
        src="https://resource.chunyu.mobi/@/media/images/2022/04/14/23d6/263fd92e9fe2_w750_h343_.jpg"
      />
      <img
        class="feedback-btn"
        src="https://resource.chunyu.mobi/@/media/images/2022/04/14/1427/1d9f1d8780a7_w172_h56_.png"
        alt=""
        @click="jumpToFeedBack"
      />
    </div>
    <img
      class="pc-img"
      src="https://resource.chunyu.mobi/@/media/images/2022/04/14/ee09/650a6d6965c5_w750_h238_.png"
    />
    <div class="footer-fix">
      <div class="footer-fix-cont">
        <p>
          合计：<span>{{ priceText }}</span>
        </p>
        <div class="pc-btn" @click="handleSubmitConfirm">立即咨询</div>
      </div>
    </div>
    <div class="footer-placeholder" />
    <Dialog
      :visible.sync="visible"
      :phone="phone"
      :is-show-cancel-btn="false"
      :title="isNormal ? '提示' : '信息确认'"
      :message="errorTip"
      :duration="duration"
      :service-time="serviceTime"
      :is-normal="isNormal"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import {
  getCompanyPsychologicalConsultDetail,
  isServiceCanUse,
  createFreeOrder,
} from '@/services';
import Dialog from '../../components/Dialog/index.vue';

const CLINIC_NO = 'nb';

export default {
  name: 'CompanyPsychologicalCounseling',
  components: {
    Dialog,
  },
  data() {
    return {
      partner: this.$route.query.partner || '', // 获取url上的panter参数
      visible: false, // 是否展示弹窗
      isNormal: false, // 是否是普通弹窗
      isEnterprise: false, // 是否属于该企业的员工
      freeCount: 0, // 剩余次数
      price: 0, // 价格
      phone: '', // 手机号
      errorTip: '', // 错误提示
      duration: 0, // 咨询时长
      serviceTime: '', // 咨询时间
    };
  },
  computed: {
    priceText() {
      if (this.price || this.price === 0) {
        return `￥${this.price}`;
      }
      return `￥--`;
    },
  },
  mounted() {
    this.getAskDetail();
  },
  methods: {
    /**
     * @description 获取咨询详情
     */
    async getAskDetail() {
      try {
        const { error_code, error_msg, data = {} } =
          (await getCompanyPsychologicalConsultDetail({
            clinic_no: CLINIC_NO,
            partner: this.partner,
          })) || {};
        if (error_code === 0) {
          const {
            price,
            free_count,
            phone,
            duration,
            service_time,
            is_enterprise_user,
          } = data;
          this.isEnterprise = is_enterprise_user;
          this.phone = phone;
          this.price = price;
          this.freeCount = free_count;
          this.duration = duration;
          this.serviceTime = service_time;
        } else {
          this.toast(error_msg || '获取详情出错');
        }
      } catch (error) {
        const { data = {}, status } = error?.response || {};
        if (status === 401) {
          window.location.href = `${window.location.origin}/cooperation/wap/quick_login/?next=${window.location.href}&need_chunyu_login=1`;
        } else {
          this.toast(data.error_msg || '获取详情出错');
        }
      }
    },

    /**
     * @description 点击立即咨询进行校验
     */
    async handleSubmitConfirm() {
      // 发请求获取用户是否可以下单
      try {
        const { error_code, error_msg } =
          (await isServiceCanUse({
            clinic_no: CLINIC_NO,
            partner: this.partner,
          })) || {};
        if (error_code !== 0) {
          this.errorTip = error_msg;
          this.isNormal = true;
        }
      } catch (error) {
        const { data = {} } = error?.response || {};
        this.isNormal = true;
        this.errorTip = data.error_msg;
      }
      this.visible = true;
    },

    /**
     * @description 点击确认按钮触发
     */
    handleSubmit() {
      // 跳转到支付页面
      if (this.isNormal) {
        // 普通按钮仅有提示功能
        this.visible = false;
      } else if (this.price !== 0) {
        // 价格为0，直接跳转到购买成功页面
        const infoDict = {
          phone: this.phone,
          clinic_no: CLINIC_NO,
        };

        const param = {
          finish_success_url: encodeURIComponent('/v-m-general/pay-success'),
          order_type: 'fast_phone',
          order_desc: '',
          order_name: '心理科极速电话服务',
          partner: this.partner,
        };
        this.jumpV2Page(param, infoDict);
      } else {
        // 发请求创建订单
        this.createFreeOrder();
      }
      this.visible = false;
    },

    /**
     * @description 创建免费的订单
     */
    async createFreeOrder() {
      try {
        const { error_code, error_msg, success_url } = await createFreeOrder({
          phone: this.phone,
          clinic_no: CLINIC_NO,
          partner: this.partner,
          coop_service_type: 'fast_phone_xinli',
        });
        if (error_code === 0) {
          // 创建成功跳转到购买成功页面
          window.location.href = success_url;
        } else {
          this.toast(error_msg || '创建订单失败');
        }
      } catch (error) {
        const { data = {} } = error?.response || {};
        this.toast(data.error_msg || '创建订单失败');
      }
    },

    /**
     * @description 跳转pay v2 支付url
     * @param {object} params 订单相关信息
     * @param {object} infoObj 其他信息
     */
    jumpV2Page(params, infoObj) {
      const url = this.getPayV2Url(params, infoObj);
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },

    /**
     * @description 获取pay v2 支付url
     * @param {object} params 订单相关信息
     * @param {object} infoObj 其他信息
     */
    getPayV2Url(params, infoObj) {
      if (!params || typeof params !== 'object') {
        return '';
      }

      const infoDict = encodeURIComponent(JSON.stringify(infoObj));

      const pay2Url = [
        '/weixin/pay/?',
        'pay_version=2',
        `&type=${params.order_type}`,
        `&order_type=${params.order_type}`,
        `&order_name=${params.order_name}`,
        `&order_desc=${params.order_desc || ''}`,
        `&partner=${params.partner || 'chunyu_wap'}`,
        `&return_url=${params.finish_success_url || ''}`,
        `&finish_success_url=${params.finish_success_url || ''}`,
        `&finish_fail_url=${params.finish_fail_url || ''}`,
        `&info=${infoDict}`,
      ].join('');

      return pay2Url;
    },

    /**
     * @description toast二次封装
     * @param {string} txt 提示内容
     * @param {number} time toast时间
     */
    toast(txt, time = 1000) {
      this.$createToast({
        time,
        txt,
        type: 'txt',
      }).show();
    },

    /**
     * @description 点击反馈跳转到反馈页面
     */
    jumpToFeedBack() {
      const env = window.location.host;
      if (env === 'biztest.chunyutianxia.com') {
        window.location.href =
          'https://biztest.chunyutianxia.com/v_m_questionnaire_vue/questionnaire/510';
      } else if (env === 'www.chunyuyisheng.com') {
        window.location.href =
          'https://www.chunyuyisheng.com/v_m_questionnaire_vue/questionnaire/1744';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.company-psychological-counseling {
  margin-bottom: env(safe-area-inset-bottom);
  padding-bottom: rem(60);
  background: #fff;
}
.banner {
  position: relative;
  width: 100%;
  height: rem(311);
  background: url(../../assets/images/banner.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .phone {
    position: absolute;
    right: rem(122);
    bottom: rem(20);
    width: rem(110);
    height: rem(35);
    color: #fff;
    font-weight: bold;
    font-size: rem(14);
    line-height: rem(35);
    text-align: center;
    background: rgba(0, 0, 0, 0);
    border: none;
    outline: none;
    &:disabled,
    &[disabled] {
      -webkit-opacity: 1;
      opacity: 1;
    }
  }
}
.pc-img {
  display: block;
  width: 100%;
}

.footer-fix {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  margin-bottom: env(safe-area-inset-bottom);
  background: #fff;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
  .footer-fix-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: rem(375);
    height: rem(60);
    margin: auto;
    padding: rem(15);
    color: #666;
    > p span {
      margin-left: rem(-5);
      color: #ff6134;
      font-weight: bold;
      font-size: rem(16);
    }
  }
  .pc-btn {
    width: rem(153);
    height: rem(44);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    line-height: rem(44);
    text-align: center;
    background: #39d167;
    border-radius: rem(22);
  }
}
.footer-placeholder {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: env(safe-area-inset-bottom);
  background: #fff;
}
.user-tip {
  position: relative;
  width: rem(375);
  line-height: rem(40);
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  .free-count {
    position: absolute;
    bottom: rem(12);
    left: 50%;
    width: rem(250);
    color: #693500;
    font-size: rem(15);
    transform: translateX(-50%);
  }
}
.feedback {
  position: relative;
  width: rem(375);
  img {
    display: block;
    width: 100%;
    height: auto;
  }
  .feedback-btn {
    position: absolute;
    bottom: rem(26);
    left: 50%;
    width: rem(84);
    height: rem(26);
    transform: translateX(-50%);
  }
}
</style>
